import i18next from 'i18next'
import languageDetector from 'i18next-browser-languagedetector'
import translations from '../locales/i18next/remote.json'

let i18nRemote = i18next
  .use(languageDetector)
  .init({
    fallbackLng: 'en',
    load: 'languageOnly',
    parseMissingKeyHandler: () => '',
    detection: {
      order: ['querystring', 'navigator']
    },
    resources: translations
  })

export default i18nRemote



// WEBPACK FOOTER //
// ./src/plugins/i18next-remote.js